import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./fonts/StabilGrotesk-Regular.woff2";
import "./fonts/StabilGrotesk-Regular.woff";
import "./fonts/StabilGrotesk-Bold.woff2";
import "./fonts/StabilGrotesk-Bold.woff";
import "./fonts/StabilGrotesk-Medium.woff2";
import "./fonts/StabilGrotesk-Medium.woff";
import "./fonts/StabilGrotesk-Light.woff2";
import "./fonts/StabilGrotesk-Light.woff";
import "./fonts/RightGrotesk-Bold.woff2";
import "./fonts/RightGrotesk-Bold.woff";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
